// Copied from @confluence/experiment-personalized-templates-v2/src/mappings/whiteboardMappings.ts
// to avoid circular dependency with @confluence/experiment-cfind-5291-template-touchpoint
import type { MessageDescriptor } from 'react-intl-next';

import { i18n } from './TemplatesI18n.tsx';

export enum WHITEBOARD_TEMPLATE_IDS {
	ACTION_PLAN = 'action-plan',
	ANNUAL_CALENDAR = 'annual-calendar-2025-2026',
	BRAINWRITING = 'brainwriting',
	CONCEPT_MAP = 'concept-map',
	CRAZY_8S_BRAINSTORMING = 'crazy-8s',
	DISRUPTIVE_BRAINSTORM = 'disruptive-brainstorm',
	EXECUTIVE_SUMMARY = 'executive-summary',
	FISHBONE_DIAGRAM = 'fishbone-diagram',
	FLOWCHART = 'flow-chart',
	FOCUS_AREA_DIAGRAM = 'focus-area-diagram',
	FOURLS_RETRO = '4ls-retro',
	GAP_ANALYSIS = 'gap-analysis',
	ICEBREAKERS = 'ice-breakers',
	INCIDENT_POSTMORTEM = 'incident-postmortem',
	NETWORK_OF_TEAMS = 'network-of-teams',
	ORG_CHART = 'org-chart',
	PRIORITIZATION_MATRIX = 'prioritization',
	PRODUCT_ROADMAP = 'product-roadmap',
	PRODUCT_VISION_BOARD = 'product-vision-board',
	ROOT_CAUSE_TEMPLATE = 'root-cause-analysis',
	SERVICE_BLUEPRINT = 'service-blueprint',
	SIMPLE_RETROSPECTIVE = 'simple-retrospective',
	STAKEHOLDER_MAPPING = 'stakeholder-mapping',
	SWIMLANES_PROCESS_MAP = 'swimlanes',
	SWOT_ANALYSIS = 'swot-analysis',
	TEAM_CHARTER_TEMPLATE = 'team-formation-guide',
	TEAM_HEALTH_MONITOR = 'health-monitor',
	TIMELINE_WORKFLOW = 'timeline-workflow',
	USER_STORY_MAP = 'user-story-map',
	WORKFLOW_TEMPLATE = 'workflow',
	ELEVATOR_PITCH = 'elevator-pitch',
}

export const WHITEBOARD_TEMPLATE_TITLE_MAPPING: Record<WHITEBOARD_TEMPLATE_IDS, MessageDescriptor> =
	{
		[WHITEBOARD_TEMPLATE_IDS.SIMPLE_RETROSPECTIVE]: i18n.simpleRetrospectiveTemplate,
		[WHITEBOARD_TEMPLATE_IDS.PRIORITIZATION_MATRIX]: i18n.prioritizationMatrixTemplate,
		[WHITEBOARD_TEMPLATE_IDS.BRAINWRITING]: i18n.brainwritingTemplate,
		[WHITEBOARD_TEMPLATE_IDS.INCIDENT_POSTMORTEM]: i18n.incidentPostmortemTemplate,
		[WHITEBOARD_TEMPLATE_IDS.FOURLS_RETRO]: i18n.fourLsTemplate,
		[WHITEBOARD_TEMPLATE_IDS.NETWORK_OF_TEAMS]: i18n.networkOfTeamsTemplate,
		[WHITEBOARD_TEMPLATE_IDS.DISRUPTIVE_BRAINSTORM]: i18n.disruptiveBrainstormTemplate,
		[WHITEBOARD_TEMPLATE_IDS.CONCEPT_MAP]: i18n.conceptMapTemplate,
		[WHITEBOARD_TEMPLATE_IDS.SWIMLANES_PROCESS_MAP]: i18n.swimlanesProcessMapTemplate,
		[WHITEBOARD_TEMPLATE_IDS.SWOT_ANALYSIS]: i18n.swotAnalysisTemplate,
		[WHITEBOARD_TEMPLATE_IDS.FOCUS_AREA_DIAGRAM]: i18n.focusAreaDiagramTemplate,
		[WHITEBOARD_TEMPLATE_IDS.USER_STORY_MAP]: i18n.userStoryMapTemplate,
		[WHITEBOARD_TEMPLATE_IDS.TIMELINE_WORKFLOW]: i18n.timelineWorkflowTemplate,
		[WHITEBOARD_TEMPLATE_IDS.FISHBONE_DIAGRAM]: i18n.fishboneDiagramTemplate,
		[WHITEBOARD_TEMPLATE_IDS.ORG_CHART]: i18n.orgChartTemplate,
		[WHITEBOARD_TEMPLATE_IDS.ICEBREAKERS]: i18n.icebreakersTemplate,
		[WHITEBOARD_TEMPLATE_IDS.SERVICE_BLUEPRINT]: i18n.serviceBlueprintTemplate,
		[WHITEBOARD_TEMPLATE_IDS.PRODUCT_VISION_BOARD]: i18n.productVisionTemplate,
		[WHITEBOARD_TEMPLATE_IDS.WORKFLOW_TEMPLATE]: i18n.workflowTemplate,
		[WHITEBOARD_TEMPLATE_IDS.TEAM_HEALTH_MONITOR]: i18n.teamHealthMonitorTemplate,
		[WHITEBOARD_TEMPLATE_IDS.FLOWCHART]: i18n.flowchartTemplate,
		[WHITEBOARD_TEMPLATE_IDS.TEAM_CHARTER_TEMPLATE]: i18n.teamCharterTemplate,
		[WHITEBOARD_TEMPLATE_IDS.ACTION_PLAN]: i18n.actionPlanTemplate,
		[WHITEBOARD_TEMPLATE_IDS.EXECUTIVE_SUMMARY]: i18n.executiveSummaryTemplate,
		[WHITEBOARD_TEMPLATE_IDS.ROOT_CAUSE_TEMPLATE]: i18n.rootCauseTemplate,
		[WHITEBOARD_TEMPLATE_IDS.STAKEHOLDER_MAPPING]: i18n.stakeholderMappingTemplate,
		[WHITEBOARD_TEMPLATE_IDS.GAP_ANALYSIS]: i18n.gapAnalysisTemplate,
		[WHITEBOARD_TEMPLATE_IDS.ANNUAL_CALENDAR]: i18n.annualCalendarTemplate,
		[WHITEBOARD_TEMPLATE_IDS.CRAZY_8S_BRAINSTORMING]: i18n.crazy8sBrainstormingTemplate,
		[WHITEBOARD_TEMPLATE_IDS.PRODUCT_ROADMAP]: i18n.productRoadmapTemplate,
		[WHITEBOARD_TEMPLATE_IDS.ELEVATOR_PITCH]: i18n.elevatorPitchTemplate,
	} as const;

export const WHITEBOARD_TEMPLATE_IDS_SET = new Set(Object.values(WHITEBOARD_TEMPLATE_IDS));
